import React, { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import MonthCalendar from "../../components/MonthCalendar";
import SessionView from "../../components/SessionView";
import TeamLogo from "../../components/TeamLogo";
import { api } from "../../lib/api";
import { monthKey, DAY_TYPES } from "../../lib/training";

export default function ClientTraining() {
  const [current, setCurrent] = useState(new Date());
  const [sessions, setSessions] = useState([]);
  const [viewing, setViewing] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/me/sessions", { params: { month: monthKey(current) } });
      setSessions(data);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [current]);

  // Find next upcoming match
  const today = new Date().toISOString().slice(0, 10);
  const nextMatch = sessions
    .filter((s) => (s.day_type === "partido" || s.day_type === "partido_suplente") && s.date >= today)
    .sort((a, b) => a.date.localeCompare(b.date))[0];

  return (
    <AppShell>
      <div className="qv-page-head" data-testid="client-training">
        <div className="label">Tu mes</div>
        <h1>Calendario de entreno</h1>
        <p className="sub">Pulsa cualquier día para ver tu sesión. Marca cada ejercicio cuando lo completes.</p>
      </div>

      {nextMatch && (
        <div className="qv-card-app" style={{ marginBottom: 18, borderColor: "rgba(225,29,46,0.4)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
            {nextMatch.match?.rival_logo_url ? (
              <TeamLogo src={nextMatch.match.rival_logo_url} alt={nextMatch.match.rival} size={54} bg="transparent" />
            ) : (
              <div style={{ width: 54, height: 54, background: "rgba(225,29,46,0.12)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <span style={{ fontFamily: "Bebas Neue", fontSize: "1.6rem", color: "var(--qv-red)" }}>VS</span>
              </div>
            )}
            <div style={{ flex: 1 }}>
              <div className="qv-overline" style={{ marginBottom: 4 }}>Próximo partido</div>
              <div style={{ fontFamily: "Bebas Neue", fontSize: "1.6rem" }}>vs {nextMatch.match?.rival || "Rival"}</div>
              <div style={{ display: "flex", gap: 12, color: "#a3a3a3", fontSize: 12, marginTop: 4, flexWrap: "wrap" }}>
                <span>{new Date(nextMatch.date + "T00:00:00").toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" })}</span>
                {nextMatch.match?.kickoff_time && <span>· {nextMatch.match.kickoff_time}</span>}
                {nextMatch.match?.location && <span>· {nextMatch.match.location}</span>}
              </div>
            </div>
            <button onClick={() => setViewing(nextMatch)} className="qv-btn-primary" style={{ fontSize: 11 }}>
              VER DETALLES
            </button>
          </div>
        </div>
      )}

      <div className="qv-card-app">
        <MonthCalendar
          sessions={sessions}
          current={current}
          onChangeMonth={setCurrent}
          onDateClick={(_, s) => s && setViewing(s)}
        />
        {loading && <div style={{ color: "#737373", textAlign: "center", marginTop: 16, fontSize: 12 }}>Cargando...</div>}
      </div>

      {viewing && (
        <SessionView
          session={viewing}
          onClose={() => setViewing(null)}
          onUpdated={(u) => {
            setSessions((arr) => arr.map((s) => (s.id === u.id ? u : s)));
            setViewing(u);
          }}
        />
      )}
    </AppShell>
  );
}
